import { useNavigate } from "react-router-dom";
import helper from "../../utils/helper";
import "../../styles/components/CollectCard.css";
const CollectPoint = ({ collectData }) => {
  let navigate = useNavigate();
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <div className="collect-card">
      <div
        className="collect-icon"
        onClick={() => {
          navigate("/point-history");
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 6.98678C14.0071 10.8436 10.8618 13.9973 7.00507 14C5.33933 14.0012 3.80927 13.4205 2.60688 12.4501C2.29422 12.1977 2.27085 11.7292 2.55497 11.445L2.87299 11.127C3.11599 10.884 3.50392 10.8574 3.77314 11.071C4.659 11.774 5.7801 12.1936 6.99999 12.1936C9.8707 12.1936 12.1935 9.87027 12.1935 7.00001C12.1935 4.1293 9.87024 1.80646 6.99999 1.80646C5.62218 1.80646 4.37079 2.34187 3.44163 3.21583L4.8742 4.6484C5.15871 4.93292 4.95721 5.41936 4.55488 5.41936H0.451613C0.202181 5.41936 0 5.21718 0 4.96775V0.864473C0 0.462142 0.486443 0.260638 0.770959 0.545126L2.16452 1.93869C3.42122 0.737711 5.12445 0 6.99999 0C10.8616 0 13.9928 3.12686 14 6.98678ZM8.89361 9.21052L9.17087 8.85403C9.40057 8.5587 9.34736 8.13308 9.05204 7.90341L7.90322 7.00986V4.06452C7.90322 3.69039 7.59993 3.3871 7.2258 3.3871H6.77419C6.40005 3.3871 6.09677 3.69039 6.09677 4.06452V7.89339L7.94299 9.32935C8.23832 9.55903 8.6639 9.50585 8.89361 9.21052Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="collect-text">
        <div className="title-card">
          <h2>แต้มสะสมบุญ</h2>
          <div className="double-line">
            <div className="line-A"></div>
            <div className="line-B"></div>
          </div>
        </div>
        <h4 className="recommender-code">รหัสแนะนำ : {collectData.myRecommenderCode}</h4>
        <h4 className="recommender-name">{collectData.firstName} {collectData.lastName}</h4>
      </div>
      <div>
        <div className="collect-circle">
          <div className="collect-circle-text">
            {helper.FN.toNumberWithCommas(collectData.point || "0")}
          </div>
          <div className="collect-circle-currency">บาท</div>
        </div>
      </div>
    </div>
  );
};
export default CollectPoint;
